import React from 'react'
import UpdateTest from '../Components/UpdateTest/UpdateTest'

const UpdateTestView = () => {
  return (
    <div>
        <UpdateTest />
    </div>
  )
}

export default UpdateTestView